import { FormElementModel } from "./../../../models/FormElementModel";
import {
  emailValidator,
  lengthValidator,
  PERSON_NAME_MAX_LENGTH,
  repeatEmailValidator,
  textValidator,
  zipCodeValidator,
} from "../../../../utils/formsValidation";
import { REQUIRED_VALIDATOR } from "../../../../messages/errorsMessages";
import { t } from "i18next";

export const userPayForm = (
  watch: any,
  register: any,
  zipCode: boolean,
): FormElementModel[] => [
  {
    name: "firstName",
    type: "text",
    text: t("imie"),
    placeholder: "Jan",
    isLabel: true,
    inputMaxLength: PERSON_NAME_MAX_LENGTH,
    register: { ...register("firstName", { ...textValidator(true, 3, PERSON_NAME_MAX_LENGTH) }) },
  },
  {
    name: "lastName",
    type: "text",
    text: t("nazwisko"),
    placeholder: "Kowalski",
    isLabel: true,
    inputMaxLength: PERSON_NAME_MAX_LENGTH,
    register: { ...register("lastName", { ...textValidator(true, 3, PERSON_NAME_MAX_LENGTH) }) },
  },
  {
    name: "email",
    type: "text",
    text: "E-mail",
    placeholder: "jan.kowalski@gmail.com",
    isLabel: true,
    register: { ...register("email", { ...emailValidator(true) }) },
  },
  {
    name: "repeatEmail",
    type: "text",
    text: t("powtorz_email"),
    placeholder: "jan.kowalski@gmail.com",
    isLabel: true,
    register: { ...register("repeatEmail", { ...repeatEmailValidator(true, watch("email", "")) }) },
  },
  zipCode
    ? {
        name: "zipCode",
        type: "text",
        text: t("kod_pocztowy"),
        placeholder: "00-000",
        isLabel: true,
        register: { ...register("zipCode", { required: false }, { ...zipCodeValidator(true) }) },
      }
    : ({} as FormElementModel),
];

export const invoiceForm = (register: any, isCompanyInvoice: boolean): FormElementModel[] => [
  isCompanyInvoice
    ? {
        name: "companyName",
        type: "text",
        text: t("nazwa_firmy"),
        placeholder: "Nazwa Sp. z o.o.",
        isLabel: true,
        register: { ...register("companyName", { ...lengthValidator(true, 3) }) },
      }
    : ({} as FormElementModel),
  // NIP field is rendered separately via EANipInput (supports country code selection)
  {
    name: "street",
    type: "text",
    text: t("ulica"),
    placeholder: "ul. Przykładowa",
    isLabel: true,
    register: { ...register("street", { ...textValidator(true, 3) }) },
  },
  {
    name: "houseNumber",
    type: "text",
    text: t("numer_domu"),
    placeholder: "1",
    isLabel: true,
    register: { ...register("houseNumber", { required: REQUIRED_VALIDATOR(t) }) },
  },
  {
    name: "flatNumber",
    type: "text",
    text: t("numer_mieszkania"),
    placeholder: "10",
    isLabel: true,
    register: { ...register("flatNumber", { required: false }) },
  },
  {
    name: "zipCode",
    type: "text",
    text: t("kod_pocztowy"),
    placeholder: "00-000",
    isLabel: true,
    register: { ...register("zipCode", { ...zipCodeValidator(true) }) },
  },
  {
    name: "city",
    type: "text",
    text: t("miejscowosc"),
    placeholder: "Warszawa",
    isLabel: true,
    register: { ...register("city", { ...textValidator(true, 3) }) },
  },
];

export const recipientInvoiceForm = (register: any): FormElementModel[] => [
  {
    name: "recipient.name",
    type: "text",
    text: t("nazwa_firmy"),
    placeholder: "Nazwa Sp. z o.o.",
    isLabel: true,
    register: { ...register("recipient.name", { ...lengthValidator(true, 3) }) },
  },
  {
    name: "recipient.locality",
    type: "text",
    text: t("miejscowosc"),
    placeholder: "Warszawa",
    isLabel: true,
    register: { ...register("recipient.locality", { ...textValidator(true, 3) }) },
  },
  {
    name: "recipient.postCode",
    type: "text",
    text: t("kod_pocztowy"),
    placeholder: "00-000",
    isLabel: true,
    register: { ...register("recipient.postCode", { ...zipCodeValidator(true) }) },
  },
  {
    name: "recipient.street",
    type: "text",
    text: t("ulica"),
    placeholder: "ul. Przykładowa",
    isLabel: true,
    register: { ...register("recipient.street", { ...textValidator(true, 3) }) },
  },
  {
    name: "recipient.houseNumber",
    type: "text",
    text: t("numer_domu"),
    placeholder: "1",
    isLabel: true,
    register: { ...register("recipient.houseNumber", { required: REQUIRED_VALIDATOR(t) }) },
  },
  {
    name: "recipient.flatNumber",
    type: "text",
    text: t("numer_mieszkania"),
    placeholder: "10",
    isLabel: true,
    register: { ...register("recipient.flatNumber", { required: false }) },
  },
  // recipient.vatId is rendered separately via EANipInput (supports country code selection)
];

export const purchaserInvoiceForm = (register: any): FormElementModel[] => [
  {
    name: "purchaser.name",
    type: "text",
    text: t("nazwa_firmy"),
    placeholder: "Nazwa Sp. z o.o.",
    isLabel: true,
    register: { ...register("purchaser.name", { ...lengthValidator(true, 3) }) },
  },
  {
    name: "purchaser.locality",
    type: "text",
    text: t("miejscowosc"),
    placeholder: "Warszawa",
    isLabel: true,
    register: { ...register("purchaser.locality", { ...textValidator(true, 3) }) },
  },
  {
    name: "purchaser.postCode",
    type: "text",
    text: t("kod_pocztowy"),
    placeholder: "00-000",
    isLabel: true,
    register: { ...register("purchaser.postCode", { ...zipCodeValidator(true) }) },
  },
  {
    name: "purchaser.street",
    type: "text",
    text: t("ulica"),
    placeholder: "ul. Przykładowa",
    isLabel: true,
    register: { ...register("purchaser.street", { ...textValidator(true, 3) }) },
  },
  {
    name: "purchaser.houseNumber",
    type: "text",
    text: t("numer_domu"),
    placeholder: "1",
    isLabel: true,
    register: { ...register("purchaser.houseNumber", { required: REQUIRED_VALIDATOR(t) }) },
  },
  {
    name: "purchaser.flatNumber",
    type: "text",
    text: t("numer_mieszkania"),
    placeholder: "10",
    isLabel: true,
    register: { ...register("purchaser.flatNumber", { required: false }) },
  },
  // purchaser.vatId is rendered separately via EANipInput (supports country code selection)
];
